/*
Copyright 2022 New Vector Ltd


Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { ComponentPropsWithoutRef, FC } from "react";

import AudioMuted from "../icons/AudioMuted.svg?react";
import AudioLow from "../icons/AudioLow.svg?react";
import Audio from "../icons/Audio.svg?react";

interface Props extends ComponentPropsWithoutRef<"svg"> {
  /**
   * Number between 0 and 1
   */
  volume: number;
}

export const VolumeIcon: FC<Props> = ({ volume, ...rest }) => {
  if (volume <= 0) return <AudioMuted {...rest} />;
  if (volume <= 0.5) return <AudioLow {...rest} />;
  return <Audio {...rest} />;
};
